export default function useFormSelectHandlers({onChange, options}) {
    /**
     * Generate the value payload to match the submission JSON format
     *
     * @param option
     * @returns {{text}}
     */
    const generateSelectValue = (option) => {
        if (option) {
            return {
                "other": {},
                [option.id]: option.item
            }
        }

        return {
            "other": {},
        }
    };

    const handleOnSelectChange = (event) => {
        const selectedOption = options.find((option) => {
            // console.log(option);
            if (option.item) {
                return option.item === event.target.value;
            }

            return option === event.target.value;
        });

        onChange(generateSelectValue(selectedOption));
    }

    return {
        generateSelectValue,
        handleOnSelectChange
    }
}